// MBTI types grouped by 16Personalities club
export const MBTI_GROUPS = [
  {
    club: "Analistas",
    description: "Intuitivos (N) + Pensadores (T) — racionalidade, imparcialidade e excelência intelectual.",
    color: "#A855F7",
    bg: "rgba(168,85,247,0.12)",
    border: "rgba(168,85,247,0.45)",
    types: [
      { code: "INTJ", label: "Arquiteto" },
      { code: "INTP", label: "Lógico" },
      { code: "ENTJ", label: "Comandante" },
      { code: "ENTP", label: "Debatedor" },
    ],
  },
  {
    club: "Diplomatas",
    description: "Intuitivos (N) + Sentimentais (F) — empatia, diplomacia e idealismo apaixonado.",
    color: "#22C55E",
    bg: "rgba(34,197,94,0.12)",
    border: "rgba(34,197,94,0.45)",
    types: [
      { code: "INFJ", label: "Advogado" },
      { code: "INFP", label: "Mediador" },
      { code: "ENFJ", label: "Protagonista" },
      { code: "ENFP", label: "Ativista" },
    ],
  },
  {
    club: "Sentinelas",
    description: "Observadores (S) + Julgadores (J) — praticidade, foco em ordem, segurança e estabilidade.",
    color: "#3B82F6",
    bg: "rgba(59,130,246,0.12)",
    border: "rgba(59,130,246,0.45)",
    types: [
      { code: "ISTJ", label: "Logístico" },
      { code: "ISFJ", label: "Defensor" },
      { code: "ESTJ", label: "Executivo" },
      { code: "ESFJ", label: "Cônsul" },
    ],
  },
  {
    club: "Exploradores",
    description: "Observadores (S) + Prospetivos (P) — espontaneidade, engenho e flexibilidade.",
    color: "#EAB308",
    bg: "rgba(234,179,8,0.12)",
    border: "rgba(234,179,8,0.45)",
    types: [
      { code: "ISTP", label: "Virtuoso" },
      { code: "ISFP", label: "Aventureiro" },
      { code: "ESTP", label: "Empresário" },
      { code: "ESFP", label: "Animador" },
    ],
  },
];

const FLAT = {};
MBTI_GROUPS.forEach((g) => g.types.forEach((t) => { FLAT[t.code] = { ...t, club: g.club, color: g.color, bg: g.bg, border: g.border }; }));

export function mbtiInfo(code) {
  if (!code) return null;
  return FLAT[String(code).toUpperCase()] || null;
}

export function clubInfo(club) {
  return MBTI_GROUPS.find((g) => g.club === club) || null;
}

export function MbtiBadge({ mbti, club, label, compact = false }) {
  const info = mbti ? mbtiInfo(mbti) : club ? clubInfo(club) : null;
  if (!info) return <span className="text-[#737373] text-xs">—</span>;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-1 text-[10px] font-bold uppercase tracking-widest border"
      style={{ background: info.bg, borderColor: info.border, color: info.color }}
    >
      {mbti && <span className="font-mono">{mbti}</span>}
      {!compact && (label || info.label || info.club)}
    </span>
  );
}
